'use client';

import React, {useState} from 'react';
import {LoadingIndicator, SkillzUI, _m, PrizeEmitter} from '@sdk-mobile';
import {IDepositOffer} from '@/services/promotions/interfaces';
import HeroBanner from '@/app/(app)/games/[gid]/sign-in/_src/HeroBanner';
import RegisterWithSMS from '@/app/(app)/games/[gid]/sign-in/_src/RegisterWithSMS';
import {StyleSheet} from 'react-native';
import LiveEventBanner from '@/app/(app)/games/[gid]/sign-in/_src/LiveEventBanner';
const {BannerAnimated} = SkillzUI;

type Props = {
  limitedTimeOffers?: IDepositOffer[];
  liveEvent?: boolean;
};

export default function SignInScreen({limitedTimeOffers = [], liveEvent}: Props) {
  const [showBanner, setShowBanner] = useState(false);

  return (
    <>
      <PrizeEmitter
        style={[{backgroundColor: 'transparent'}, StyleSheet.absoluteFill]}
        amountWon={1}
        isCashWin={true}
        shouldShowPrizeRain={true}
        shouldVibrate={false}
        tierBadgeImage={'/sms_coin.png'}
        key={'sms_coin'}
      />
      <div className='fixed inset-0 bg-black bg-opacity-10 opacity-30'></div>
      {showBanner ? (
        <div className='absolute z-10 mt-4'>
          <BannerAnimated
            title={_m('Code Resent')}
            message={_m('This code expires in 10 minutes')}
            onClosePress={() => setShowBanner(false)}
          />
        </div>
      ) : null}
      {liveEvent ? <LiveEventBanner /> : <HeroBanner limitedTimeOffers={limitedTimeOffers} />}
      <RegisterWithSMS liveEvent={liveEvent} setShowBanner={setShowBanner} />
      <LoadingIndicator />
    </>
  );
}
